"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SearchController_js_1 = require("./SearchController.js");
exports.SearchController = SearchController_js_1.SearchController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/search/controllers/index.ts
// module id = 467
// module chunks = 0